// TODO: price type ids to be changed - theres a conflict
const PERMANENT_MARKDOWN_PRICE_TYPE = 88888;
const NEW_MARKDOWN_PRICE_TYPE = 7;

/**
 * This function formats gift price text
 * @param {string} priceLabel Array with price information
 * @returns {string} Returns modified string
 */
function formatGiftPriceLabel(priceLabel = '') {
  return priceLabel.toLowerCase().startsWith('a ')
    ? priceLabel.slice(2)
    : priceLabel;
}

/**
 * This function removes placeholder labels for the price objects and creates new properties for regular and discount prices
 * @param {TieredPrice} tieredPrice Array with price information
 * @returns {TieredPrice} Returns modified object
 */
function formatPriceLabelInTieredPrice(tieredPrice) {
  tieredPrice.forEach((labels, index) => {
    if (labels.label.includes('PRICE]')) {
      labels.label = labels.label.replace('[PRICE]', '').trim();
      labels.id = index;
    }
    // creating new placeholders to determine the type to publish on template.
    const { values } = labels;
    values.forEach((valueArray) => {
      if (valueArray.type === 'regular') valueArray.regular = true;
      else if (valueArray.type === 'discount') valueArray.discount = true;
    });
  });

  return tieredPrice;
}

/**
 * This function formats price data so it can be used on UI side
 * @param {Pricing} selectedPrice - price object
 * @param {OffersData} offersData Offers object that contains info about promos and sales

 * @returns {object}
 */
/* eslint-disable complexity */
function getSelectedPriceData(selectedPrice, offersData, options = {}) {
  const price = selectedPrice?.price || {};

  const {
    finalPrice = { promoCode: '' },
    tieredPrice = [],
    priceType = { onSale: false, giftPriceLabelToAllUpcs: '', text: '' },
    priceTypeId,
  } = price;

  const { onSale, giftPriceLabelToAllUpcs } = priceType;

  const giftpriceLabelFormatted = formatGiftPriceLabel(
    giftPriceLabelToAllUpcs,
  );

  const isFinalPrice = !!offersData.withOffer;
  const isWithOfferPromo = isFinalPrice && finalPrice.promoCode;

  const promoCodeOffers = options.isColorwayPrice ? offersData.lists?.selectedColorOffers : offersData.lists?.activeOffers;

  const promoCodeOffer = (promoCodeOffers || []).find(
    (el) => el.promoCode,
  );
  const promoCodeHeader = promoCodeOffer && !isFinalPrice ? promoCodeOffer.header : '';

  const isPromotionWithCode = !!(isFinalPrice || promoCodeOffer);

  const isPermanentMarkdown = priceTypeId === PERMANENT_MARKDOWN_PRICE_TYPE;
  const isNewMarkdown = priceTypeId === NEW_MARKDOWN_PRICE_TYPE;
  const regularPriceTier = tieredPrice[0] || {};
  const salePriceTier = tieredPrice[tieredPrice.length - 1] || {};
  const lowestSalePriceTier = isFinalPrice ? finalPrice : salePriceTier;

  const isShowRegularPrice = !giftPriceLabelToAllUpcs
        && ((onSale && !promoCodeOffer) || isFinalPrice);

  const isSaleLabel = !!(
    onSale
        && !isFinalPrice
        && (promoCodeOffer || giftPriceLabelToAllUpcs)
  );
  const isLowestPriceRed = (onSale || isPromotionWithCode || giftPriceLabelToAllUpcs)
        && (onSale || isFinalPrice);

  salePriceTier.isOverlayPriceStyled = onSale && !isWithOfferPromo;

  const isLastAct = priceType?.text && priceType?.text.toLowerCase() === 'last act';
  const isEverydayValue = priceType?.text && priceType?.text.toLowerCase() === 'everyday value';
  const isTwoTier = tieredPrice.length === 2;
  const isMultiTier = tieredPrice.length > 1;
  const lastActFormatted = isLastAct ? 'Last Act' : '';

  return {
    priceType,
    lastActFormatted,
    priceTypeId,
    tieredPrice: formatPriceLabelInTieredPrice(tieredPrice),
    regularPriceTier,
    lowestSalePriceTier,
    giftpriceLabelFormatted,
    giftPriceLabel: giftPriceLabelToAllUpcs,
    promoCodeHeader,
    percentOff: lowestSalePriceTier?.values?.[0]?.percentOff?.[0] || '',
    offers: offersData,
    flags: {
      isSaleLabel,
      isShowRegularPrice,
      isLowestPriceRed,
      isWithOfferPromo,
      isLastAct,
      isEverydayValue,
      isTwoTier,
      isMultiTier,
      isPermanentMarkdown,
      isNewMarkdown,
    },
  };
}

export default getSelectedPriceData;
